import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'
import client_lookup from '@/assets/json/clientLookups.json'

const lookupLocalMaritalStatusIdWatchAction = (options) => {
  const lookupLocalMaritalStatusIdWatch = ref()
  const formStore = useFormStore()
  const { Divorced, Widowed, Married } = client_lookup.maritalStatuses
  const { exHusband, husband } = client_lookup.relationships

  lookupLocalMaritalStatusIdWatch.value = watch(
    () => formStore.form.values.lookupLocalMaritalStatusId,
    (newVal) => {
      if (newVal && [Divorced, Widowed].includes(newVal)) {
        formStore.form.setFieldValue('lookupLocalRelationId', exHusband)
      }
      if (newVal == Married) {
        formStore.form.setFieldValue('lookupLocalRelationId', husband)
      }
    }
  )
  onUnmounted(() => {
    lookupLocalMaritalStatusIdWatch.value && lookupLocalMaritalStatusIdWatch.value()
  })
}
export default function () {
  return {
    lookupLocalMaritalStatusIdWatchAction
  }
}
